import React, { useEffect, useState } from "react";
import { slide as Menu } from "react-burger-menu";
import { NavLink } from "react-router-dom";
import "./Header.scss";

import { getRegisterUrl } from "../helpers/getRegisterUrl";
import useScrollDirection from "../hooks/useScrollDirection";
// @ts-expect-error
import logo from "../logo.svg";
// @ts-expect-error
import logo_red from "../logo_red.svg";

function Header() {
	const scrollDirection = useScrollDirection();
	const [menuOpen, setMenuOpen] = useState(false);

	const closeMenu = (event: React.MouseEvent<HTMLAnchorElement>) => {
		event.preventDefault();
	};

	const links = [
		<NavLink
			tabIndex={0}
			className={(navData) => (navData.isActive ? "active" : "")}
			to="/"
			onClick={(event) => closeMenu(event)}
			key={"link_arbeitnehmer"}
		>
			Arbeitnehmer
		</NavLink>,
		<NavLink
			tabIndex={0}
			className={(navData) => (navData.isActive ? "active" : "")}
			to="/arbeitgeber"
			onClick={(event) => closeMenu(event)}
			key={"link_arbeitgeber"}
		>
			Arbeitgeber
		</NavLink>,
		<NavLink
			tabIndex={0}
			className={(navData) => (navData.isActive ? "active" : "")}
			to="/haendler"
			onClick={(event) => closeMenu(event)}
			key={"link_haendler"}
		>
			Radl-Händler
		</NavLink>,
		<NavLink
			tabIndex={0}
			className={(navData) => (navData.isActive ? "active" : "")}
			to="/marken"
			onClick={(event) => closeMenu(event)}
			key={"link_marken"}
		>
			Marken
		</NavLink>,
		<NavLink
			tabIndex={0}
			className={(navData) => (navData.isActive ? "active" : "")}
			to="/ablauf"
			onClick={(event) => closeMenu(event)}
			aria-current="page"
			key={"link_ablauf"}
		>
			Ablauf
		</NavLink>,
		// <NavLink
		// 	tabIndex={0}
		// 	className={(navData) => (navData.isActive ? "active" : "")}
		// 	to="/gewinnspiel"
		// 	onClick={closeMenu}
		// 	key={"link_gewinnspiel"}
		// >
		// 	Gewinnspiel
		// </NavLink>,
		<NavLink
			tabIndex={0}
			className={(navData) => (navData.isActive ? "active" : "")}
			to="/kontakt"
			onClick={(event) => closeMenu(event)}
			key={"link_kontakt"}
		>
			Kontakt
		</NavLink>,
		<a
			tabIndex={0}
			href={getRegisterUrl()}
			target="_blank"
			className="button"
			rel="noreferrer"
			onClick={(event) => closeMenu(event)}
			key={"link_login_register"}
		>
			Login & Registrierung
		</a>,
	];

	const getCurrentLinks = () => {
		const activeLink = document.querySelector('.active');
		if (activeLink) {
			return document.querySelectorAll(`a[tabindex="0"]`);
		}
		return [];
	};

	const handleMouseClick = (event: MouseEvent) => {
		const currentLinks = getCurrentLinks();
		if (currentLinks.length > 0) {
			const targetLink = event.target as HTMLAnchorElement;
			if (targetLink.href) {
				window.location.href = targetLink.href;
			}
		}
	};

	const handleMouseMove = (event: MouseEvent) => {
		const currentLinks = getCurrentLinks();
		if (currentLinks.length > 0) {
			const targetLink = event.target as HTMLAnchorElement;
			if (targetLink) {
				targetLink.focus();
			}
		}
	};

	const handleKeyDown = (event: KeyboardEvent) => {
		const currentLinks = getCurrentLinks();
		if (currentLinks.length > 0) {
			if (event.key === 'ArrowUp') {
				event.preventDefault();
				(currentLinks[0] as HTMLElement).focus();
			} else if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
				let currentIndex = -1;
				for (let i = 0; i < currentLinks.length; i++) {
					if (currentLinks[i] === document.activeElement) {
						currentIndex = i;
						break;
					}
				}
				if (currentIndex !== -1 && currentIndex < currentLinks.length - 1) {
					event.preventDefault();
					setTimeout(() => {
						(currentLinks[currentIndex + 1] as HTMLElement).focus();
					}, 0);
				} else if (currentIndex === currentLinks.length - 1) {
					(currentLinks[0] as HTMLElement).focus();
				}
			} else if (event.key === 'ArrowLeft') {
				let currentIndex = -1;
				for (let i = 0; i < currentLinks.length; i++) {
					if (currentLinks[i] === document.activeElement) {
						currentIndex = i;
						break;
					}
				}
				if (currentIndex !== -1 && currentIndex > 0) {
					event.preventDefault();
					setTimeout(() => {
						(currentLinks[currentIndex - 1] as HTMLElement).focus();
					}, 0);
				} else if (currentIndex === 0) {
					(currentLinks[currentLinks.length - 1] as HTMLElement).focus();
				}
			}
			if (event.key === 'Enter') {
				const currentLink = document.activeElement as HTMLAnchorElement;
				if (currentLink.href) {
					window.location.href = currentLink.href;
				}
			}
		}
	};



	useEffect(() => {
		document.addEventListener('keydown', (e) => handleKeyDown(e));
		document.addEventListener('mousemove', (e) => handleMouseMove(e));
        document.addEventListener('click', (e) => handleMouseClick(e));
		return () => {
			document.removeEventListener('keydown', (e) => handleKeyDown(e));
			document.removeEventListener('mousemove',(e) => handleMouseMove(e));
		    document.removeEventListener('click', (e) => handleMouseClick(e));
		};
	}, []);


	return (
		<header
			className={`Header ${scrollDirection === "down" ? "hide" : "show"}`}
		>
			<div className="content">
				<NavLink
					className={(navData) => (navData.isActive ? "active" : "")}
					to="/"
					  onClick={(e) => {
						e.preventDefault();
						 window.location.href = "/cms"; 
						}}
				>
					<picture className={"logo"}>
						<img
							src={logo}
							alt="Logo von FIRMENRADL"
							title="Logo von FIRMENRADL"
							aria-hidden="true"
							className={"white"}
							width={152}
						/>
						<img
							src={logo_red}
							alt="Logo von FIRMENRADL"
							title="Logo von FIRMENRADL"
							aria-hidden="true"
							className={"red"}
							width={152}
						/>
					</picture>
				</NavLink>

				<nav className={"desktop"} role="navigation">
					<ul>
						{links.map((link) => (
							<li key={`link_desktop_${link.key}`}>{link}</li>
						))}
					</ul>
				</nav>
				<nav className={"mobile"} role="navigation">
					<Menu
						width={"100vw"}
						right
						aria-label="menunav"
						aria-controls="main-content"
						isOpen={menuOpen}
						onOpen={() => setMenuOpen(true)}
						onClose={() => setMenuOpen(false)}
						aria-expanded={menuOpen}
					>
						{links.map((link) => link)}
					</Menu>
				</nav>
			</div>
		</header>
	);
}

export default Header;
